import { TranslateService } from "@ngx-translate/core";
import { CalibrationBalance, CalibrationBalanceEssayAsFound, CalibrationBalanceVariable } from "../model/calibrationBalance";
import { InternalEquipment } from "../model/internalEquipment";
import { StringUtils } from "./stringUtils";
import { ParticleCalibration } from "../model/particleCalibration";

export class CalibrationParticlesUtils {

    public static getNameForCalibration(calibration: ParticleCalibration, eq: InternalEquipment, translate: TranslateService): string {
        const documentCode = calibration.certificateNum;
        const versionName = 'v.' + calibration.currentVersion.toString().padStart(2, '0');
        let equipment = null;
        let serialNum = null;
        let clientName = null;
        let identificative = null;

        if (eq != null) {
            equipment = eq.equipment;

            if (StringUtils.isNotEmpty(eq.serialNum)) {
                serialNum = '(' + eq.serialNum + ')';
            }

            if (eq.client != null) {
                clientName = eq.client.name;
            }

            if (eq.name != null) {
                identificative = '(' + eq.name + ')';
            }
        }

        const name = [documentCode, versionName, clientName, equipment, identificative, serialNum]
            .filter((s: string) => StringUtils.isNotEmpty(s)).join(' ');

        return translate.instant('calibrateEquipmentEdit.files.certificate', { name }) as string;
    }
}
